module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"empty":"scratch","express":"Express-template","text":"Can\u0027t find a template? Start from {scratch}, or use the {express}."}}')
  delete Component.options._Ctor
}
